import { render, staticRenderFns } from "./ElementVideoOnly.vue?vue&type=template&id=65f57ec2&"
import script from "./ElementVideoOnly.vue?vue&type=script&lang=js&"
export * from "./ElementVideoOnly.vue?vue&type=script&lang=js&"
import style0 from "./ElementVideoOnly.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
